module.exports = __webpack_public_path__ + "img/thumbnail_GiantAnteater_m_normal.0364a4a6.png";